/**
 * The API base URL as an absolute URL, for anything copied out of the browser (curl commands,
 * script examples). In production the portal and API share a host, so the configured base is the
 * relative `/api`; a command pasted into a terminal needs `https://<host>/api`.
 */
export const absoluteApiBaseUrl = (baseUrl: string, origin: string): string =>
  new URL(baseUrl, origin).href.replace(/\/$/, '');
